import {Collapse} from "reactstrap";
import * as React from "react";
import {WithUrlFragment} from "../../../util/WithUrlFragment";
import {NavLink} from "react-router-dom";
import {recordEvent} from "../plugins/metricPlugin";
import {Fragment} from "react";

/**
 * Nav Rendering Utilities.
 * Some common layout rendering utilities so they don't have to be duplicated among the various Layouts.
 */
export const renderChildDropdown = (node) => {
  if (!node.children || !node.children.length) return undefined;
  return (
    <div className="ml-auto">
      <i className={`far fa-chevron-down ${node.active ? "rotate-180" : ""} animate-rotate ml-auto nav-dropdown-chevron`}></i>
    </div>
  );
};

export const renderL1NodeWithSections = (l1Nodes) => renderNavSections(l1Nodes);

export const renderL1NodeWithoutSections = (node, idx, ctx) => {
  const { path, title, active, icon } = node;
  return (
    <div key={idx} className="nav-link-margin">
      <div className="font-weight-bold d-flex flex-row align-items-center">
        <NavItem id={!!path ? `path-${path.replace(/\//g,"-")}` : ""} path={path} key={path} containerClassName="w-100" className={`d-flex align-items-center justify-content-between ${!!ctx.navL2 ? "has-children" : ""}`}>
          <span className={`fa-fw ${icon} menu-icon`} />
          <span className="control-spacer-left mr-auto">{title}</span>
          { renderChildDropdown(node) }
        </NavItem>
      </div>
      {!!ctx.navL2 && <Collapse isOpen={active} className="nav-accordion">
        { renderNavSections(ctx.navL2) }
      </Collapse>}
    </div>
  );
};

export const renderNav = (ctx) => {
  const navL1Nodes = ctx.navL1.filter(x => !x.excludeFromMenu);
  const navL1HasSections = navL1Nodes.some(n => n.isSection);
  if (navL1HasSections) return renderL1NodeWithSections(navL1Nodes);
  return navL1Nodes.map((node, idx) => {
    return renderL1NodeWithoutSections(node, idx, ctx);
  });
};

export const renderNavSections = (nodes) => {
  if (!nodes) return undefined;
  const isSingleSection = nodes.length === 1;
  const sections = nodes.map((section, idx) => {
    return (
      <div key={`${section.title}-${idx}`}>
        { !isSingleSection && section.title !== "Default" && <div className="dropdown-header"><span>{section.title}</span></div> }
        {
          section.children.filter(x => !x.excludeFromMenu).map((childNode) => {
            return (
              <div key={`${section.title}-${childNode.path}`} className="nav-link-margin">
                <NavItem path={childNode.path} active={childNode.active} eventName={childNode.eventName} exact={childNode.exact}>
                  {!!childNode.icon ? <Fragment>
                    <span className={`fa-fw ${childNode.icon} menu-icon`} />
                    <span className="control-spacer-left mr-auto">{childNode.title}</span>
                  </Fragment> : <Fragment>
                    <i className="far fa-fw"></i>
                    <span className="control-spacer-left child-title">{childNode.title}</span>
                  </Fragment>}
                </NavItem>
              </div>
            );
          })
        }
      </div>
    );
  });
  return <div>{sections}</div>;
};

/** retains url params */
export function NavItem({ path, children, active, eventName, exact, className, containerClassName, id }) {
  return <WithUrlFragment>{
    ({ pathname, search }) => {
      return <li className={containerClassName || ""}><NavLink
        id={id}
        isActive={() => active}
        className={`nav-item nav-link ${className || ""}`}
        onMouseDown={eventName && (() => recordEvent(eventName))}
        exact={exact}
        to={{
          pathname: path,
          search: search
        }}>
        { children }
      </NavLink></li>
    }

  }</WithUrlFragment>
}
